import React from 'react';

export const AuthFormSection = ({ children }) => (
  <div className="w-full max-w-md">
    <div className="rounded-3xl border border-border bg-panel p-6 shadow-floating sm:p-8">
      {children}
    </div>
  </div>
);
